import React from 'react';
import { Image, RestaurantSignUp, StoreBadges } from '../components';
import './Columns.scss';

export const Columns = props => {
  const { data } = props;
  const { primary, items = [] } = data;
  const { title, classname } = primary;
  const customClassName = classname ? classname.text : '';
  return (
    <section className={`columns-section ${customClassName}`}>
      <div className="wrapper">
        {title && title.text && <h3 className="columns-section-title">{title.text}</h3>}
        <div className="columns-section-grid">
          {items.map((item, index) => (
            <div className="columns-section-column" key={item.title ? item.title.text : index} data-column={index + 1}>
              {item.image && (item.image.localFile || item.image.url) && <Image image={item.image} />}
              {item.icon && item.icon.url && <img src={item.icon.url} alt={item.title.text} />}
              <h4 className="columns-section-column-title">{item.title.text}</h4>
              {item.content && item.content.html && (
                <div className="" dangerouslySetInnerHTML={{ __html: item.content.html }} />
              )}
            </div>
          ))}
        </div>
        {customClassName === 'restaurants-sign-up' && (
          <div className="columns-section-sign-up">
            <RestaurantSignUp />
          </div>
        )}
      </div>
    </section>
  );
};
